import { render, staticRenderFns } from "./ProductCategoriesPage.vue?vue&type=template&id=2471243f"
import script from "./ProductCategoriesPage.vue?vue&type=script&lang=js"
export * from "./ProductCategoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports